export default "__VITE_ASSET__DHFbs4u4__"